import { TokenClaimModel } from "../models/security.model";

const TOKEN_KEY = "tokenOpration";
const FLAG_FORCE = "flagForcePassword";

export const setJwtToken = (token: string) => {
  localStorage.setItem(TOKEN_KEY, token);
};
export const setForceChangePassword = (flagForcePassword: string) => {
  localStorage.setItem(FLAG_FORCE, flagForcePassword);
};

export const getJwtToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEY);
};

export const getForceChangePassword = (): boolean | null => {
  return 'true' === localStorage.getItem(FLAG_FORCE);
};

export const getTokenClaims = (): TokenClaimModel | null => {

  const token = getJwtToken();
  if (token == undefined  || token=='') return null;
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload) as TokenClaimModel;
};

export const isTokenValid = (): boolean => {
  const token = getJwtToken();
  if(!token) return false;
  const tokenClaims = getTokenClaims();
  if (!tokenClaims) return false;
  // if (tokenClaims.exp * 1000 < Date.now()) return false;
  return true;
};
